import React from 'react';
import { DatePicker } from 'antd';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const CHART_COLORS = {
	blue: '#1B71E7',
	orange: '#E7711B',
	gray: '#999999',
	darkBlue: '#0B21a7',
	lightGray: '#a1a1a1',
	lightBlue: '#aaaaff',
	lightRed: '#ffaaaa',
	red: '#eb4b4b',
	yellow: '#F0C355',
	green: '#19A04B',
	skyBlue: '#31B4F2',
	navy: '#005693',
	tan: '#ED965D',
	darkGray: '#717171',
	intervalBlue: '#0000ff',
	transparent: 'transparent',
	backgroundColor: '#fff'
};

export const StyledDatePicker = styled(DatePicker)`
	border-radius: 4px;
	.ant-picker-focused, &:hover {
		border-color: ${themeGet('colors.primary')};
	}
`;

export const StyledDatePickerPanel = styled.div`
	.ant-picker-today-btn {
		color: ${themeGet('colors.primary')};
	}
	.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
		border-color: ${themeGet('colors.secondary')};
	}
	.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
		background: ${themeGet('colors.primary')};
	}
`;

export const modalPositionStyle: React.CSSProperties = {
	top: 20,
	left: 20,
	right: 20,
	bottom: 20
};

export const modalBodyStyle: React.CSSProperties = {
	height: '85vh',
	maxHeight: 'calc(100vh - 120px)',
	overflowY: 'auto'
};
export const relativeChartContainerStyle: React.CSSProperties = { position: 'relative' };
export const combinedChartContainerStyle: React.CSSProperties = { display: 'relative' };
export const riskChartFilterStyle: React.CSSProperties = { position: 'absolute', top: 0, right: 20, zIndex: 1 };
export const riskChartLabelsStyle: React.CSSProperties = {
	position: 'absolute',
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	justifyContent: 'space-between',
	top: '25%',
	bottom: '25%',
	left: '10%'
};
export const rotatedChartLabelStyle: React.CSSProperties = { transform: 'rotate(-60deg)' };
export const combinedHotDryLabelStyle: React.CSSProperties = { position: 'absolute', left: '9.35%', top: '20%', transform: 'rotate(-60deg)' };
export const combinedMildLabelStyle: React.CSSProperties = { position: 'absolute', left: '10%', top: '49%', transform: 'rotate(-60deg)' };
export const combinedColdWetLabelStyle: React.CSSProperties = { position: 'absolute', left: '9.6%', bottom: '20%', transform: 'rotate(-60deg)' };

export const nitrogenControlsContainerStyle: React.CSSProperties = { padding: 20 };
export const nitrogenInputsContainerStyle: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', gap: 12 };
export const nitrogenInputStyle: React.CSSProperties = { width: '100%', maxWidth: 200 };
export const nitrogenTooltipStyle = 'padding: 10px 12px; font-size: 16px; min-width: max-content; white-space: nowrap';
export const historicalRangeTooltipStyle: React.CSSProperties = { display: 'inline-block' };
export const historicalRangeSelectStyle: React.CSSProperties = { minWidth: 200, marginLeft: 0 };
export const nitrogenLoadingStyle: React.CSSProperties = { padding: 20, display: 'flex', justifyContent: 'center' };
export const nitrogenMessageStyle: React.CSSProperties = { padding: 20 };